import { render, staticRenderFns } from "./ApprovalStatusIndicator.vue?vue&type=template&id=6ff0987c&"
import script from "./ApprovalStatusIndicator.vue?vue&type=script&lang=js&"
export * from "./ApprovalStatusIndicator.vue?vue&type=script&lang=js&"
import style0 from "./ApprovalStatusIndicator.vue?vue&type=style&index=0&id=6ff0987c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports